/**
 * Utilidades de validación compartidas.
 *
 * Funciones puras reutilizables por todos los formularios
 * (CAUForm, RecibiForm, etc.) para mantener consistencia.
 */

/**
 * Valida formato de email.
 * @param {string} email
 * @returns {boolean}
 */
export const validateEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');

/**
 * Valida formato de teléfono (acepta +, dígitos, espacios, guiones, paréntesis).
 * Entre 6 y 20 caracteres.
 * @param {string} phone
 * @returns {boolean}
 */
export const validatePhone = (phone) =>
  /^[+\d\s\-()]{6,20}$/.test(phone || '');

/**
 * Valida que un valor no esté vacío (trim).
 * @param {string} value
 * @returns {boolean}
 */
export const isNotEmpty = (value) =>
  typeof value === 'string' && value.trim().length > 0;

/**
 * Valida longitud mínima de un string (trim).
 * @param {string} value
 * @param {number} min
 * @returns {boolean}
 */
export const hasMinLength = (value, min) =>
  typeof value === 'string' && value.trim().length >= min;

/**
 * Valida formato de fecha ISO (YYYY-MM-DD).
 * @param {string} date
 * @returns {boolean}
 */
export const validateIsoDate = (date) =>
  /^\d{4}-\d{2}-\d{2}$/.test(date || '');
